export const searchLimit = 10
export const autocompletionPageLimit = 50
export const singleItemPageLimit = 40
export const largePageLimit = 100
export const timeBeforeStartingResearch = 200
export const startingPage = 1

export const LEAVING_WARNING_MESSAGE =
  'En poursuivant pour perdrez toute les modifications non sauvegardées. Êtes vous sûr(e) de vouloir quitter la page?'

export enum VisibilityType {
  ALL = 'Tous',
  PUBLIC = 'Publics',
  PRIVATE = 'Privés',
}

const visibilityTypes = Object.values(VisibilityType)

export const isVisibilityType = (value: string): value is VisibilityType =>
  visibilityTypes.includes(value as VisibilityType)

export const NewVersionLabel = 'NEW_VERSION_FOUND'

export const mediumTransitionDuration = 500
